// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'home-solid';

export const Component = () => (
  <path
    fill='currentColor'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M2.808 9.72v6.912h4.464v-4.464c0-.648.504-1.152 1.152-1.152h1.152c.648 0 1.152.504 1.152 1.152v4.464h4.464V9.72zM.576 9.36l7.632-7.704a1.13 1.13 0 0 1 1.584 0l7.632 7.704z'
  />
);

export const viewBox = '0 0 18 18';
